import { preferencesStorageCache, zonedDate } from "@repo/lib";
import { useRouter } from "@tanstack/react-router";

export const GeneralTermsSeeLaterButton = (): JSX.Element => {
  const router = useRouter();

  const onClickHandler = async (): Promise<void> => {
    const pendingTermsOfUseAgreed = "pendingTermsOfUseAgreedNotification";

    const now: Date = zonedDate(new Date());

    await preferencesStorageCache.set(pendingTermsOfUseAgreed, now);

    void router.navigate({
      to: "/calendar/",
    });
  };

  return (
    <div className="w-fit">
      <button
        type="button"
        onClick={() => {
          void onClickHandler();
        }}
        className="text-neutral-500 text-md font-medium hover:text-neutral-600 cursor-pointer text-center"
      >
        Ver depois
      </button>
    </div>
  );
};
